import firebase from '../../firebase';

export default function getCurrentUserId() {
    const currentUser = firebase.auth().currentUser || {};
    return currentUser.uid;
}
